import {
    generateDefaultState,
    getActionTypes,
} from '../../../utils/reduxHelper';

export const actions = getActionTypes('exportLogs', [
    'GET_TABLE_LOG',
    'GET_FILE_LOG',
    'CLEAN_UP_TABLE',
    'CLEAN_UP_DISK',
    'CLEAN_UP_LOG',
    'SET_FILTERS',
    'GET_LOG_PARSER'
]);
export const initialDevOpsToolState = {
    ...generateDefaultState('exportLogs', [
        'GET_TABLE_LOG',
        'GET_FILE_LOG',
        'CLEAN_UP_TABLE',
        'CLEAN_UP_DISK',
        'CLEAN_UP_LOG',
        'SET_FILTERS',
        'GET_LOG_PARSER'
    ]),
};
